class TabItemsUtils {

  updateTableRow(items, data, addFlag) {
    const index = items.map(e => e.id).indexOf(data.id);
    if (index >= 0) {
      for (let key in data) {
        items[index][key] = data[key];
      }
    }
    if (addFlag) {
      items.push(data)
    }
  }
}

export default new TabItemsUtils()
